let bodyScrollLocked = false;

function getTopFromWindow($el) {
  let $elem = $el;
  let dist = 0;
  if ($elem.offsetParent) {
    do {
      dist += $elem.offsetTop;
      $elem = $elem.offsetParent;
    } while ($elem);
  }
  return dist;
}

function isBodyScrollLocked() {
  return bodyScrollLocked;
}

function lockBodyScroll() {
  if (bodyScrollLocked) return;
  document.body.style.overflow = 'hidden';
  bodyScrollLocked = true;
}

function unlockBodyScroll() {
  if (!bodyScrollLocked) return;
  document.body.style.overflow = '';
  bodyScrollLocked = false;
}

function scrollToElement($el, offset = 0) {
  const top = getTopFromWindow($el) - offset;
  window.scrollTo(0, top);
}

export default {
  isBodyScrollLocked,
  lockBodyScroll,
  unlockBodyScroll,
  scrollToElement,
};
